import { render, staticRenderFns } from "./establishment.vue?vue&type=template&id=4719893e&"
import script from "./establishment.vue?vue&type=script&lang=js&"
export * from "./establishment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports